import { resolveEnemy, type EnemyDef } from '../../content/enemies/enemies';
import { protagonist } from '../../content/protagonist/protagonist';
import type { CombatState, GameMode } from '../game/types';

/** Scale encounter stats by floor while preserving authored behavior/content. */
export function scaleEnemyForFloor(enemy: EnemyDef, floorNumber: number): EnemyDef {
  const depth = Math.max(0, floorNumber - 1);
  const hpMultiplier = 1 + depth * 0.2;
  const rewardMultiplier = 1 + depth * 0.16;
  return {
    ...enemy,
    maxHp: Math.ceil(enemy.maxHp * hpMultiplier),
    accuracy: Math.min(0.95, enemy.accuracy + depth * 0.012),
    expReward: Math.ceil(enemy.expReward * rewardMultiplier),
    goldReward: Math.ceil(enemy.goldReward * rewardMultiplier),
  };
}

export function buildCombatFromEnemy(
  roomId: string,
  enemyIdOrName: string,
  openingMessage: string,
  floorNumber = 1,
): { mode: GameMode; combat: CombatState } {
  const enemy = scaleEnemyForFloor(resolveEnemy(enemyIdOrName), floorNumber);
  const combatId = `combat-${roomId}-${enemy.id}`;

  return {
    mode: { type: 'combat', combatId },
    combat: {
      id: combatId,
      enemyId: enemy.id,
      enemyName: enemy.name,
      enemyDescription: enemy.description,
      enemyHp: enemy.maxHp,
      enemyMaxHp: enemy.maxHp,
      enemyAccuracy: enemy.accuracy,
      enemySkillIds: [...enemy.skillIds],
      enemyTurn: 0,
      floorNumber,
      expReward: enemy.expReward,
      goldReward: enemy.goldReward,
      sourceRoomId: roomId,
      log: [openingMessage, enemy.description, 'Bạn luôn được hành động trước.'],
      playerStatuses: protagonist.statuses.map((status) => ({ ...status })),
      enemyStatuses: enemy.statuses.map((status) => ({ ...status })),
    },
  };
}
